module.exports = __webpack_public_path__ + "img/figure-4.796528f1.png";